var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPsychology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#a17bcf",
    d: "M 354.5,38.5 C 288.5,38.5 222.5,38.5 156.5,38.5C 156.279,29.5612 160.279,23.3945 168.5,20C 197.628,18.8535 226.795,18.3535 256,18.5C 283.5,18.6667 311,18.8333 338.5,19C 349.141,21.1042 354.475,27.6042 354.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#a079ce",
    d: "M 105.5,90.5 C 82.9084,91.4889 60.2417,91.8222 37.5,91.5C 35.5665,85.0722 31.8998,79.9055 26.5,76C 20.9187,73.1402 15.2521,70.4735 9.5,68C 4.7741,64.0225 1.44077,59.1892 -0.5,53.5C -0.5,48.1667 -0.5,42.8333 -0.5,37.5C 2.98151,29.1865 8.98151,23.3531 17.5,20C 39.1296,18.4018 60.7963,18.0685 82.5,19C 95.9687,20.1358 104.135,27.3025 107,40.5C 106.325,57.1436 105.825,73.8102 105.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#9f78cd",
    d: "M 156.5,38.5 C 222.5,38.5 288.5,38.5 354.5,38.5C 354.325,44.6817 351.658,49.515 346.5,53C 337.536,55.3321 328.536,57.6655 319.5,60C 305.864,66.4629 297.198,76.9629 293.5,91.5C 268.328,91.169 243.328,91.5023 218.5,92.5C 214.497,77.6512 205.497,66.8179 191.5,60C 182.464,57.6655 173.464,55.3321 164.5,53C 159.366,49.5692 156.7,44.7358 156.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#a079ce",
    d: "M 511.5,37.5 C 511.5,42.8333 511.5,48.1667 511.5,53.5C 509.559,59.1892 506.226,64.0225 501.5,68C 494.554,70.8061 487.888,74.1394 481.5,78C 477.585,82.3435 474.585,87.1768 472.5,92.5C 450.264,91.1738 427.931,91.1738 405.5,92.5C 405.253,75.1411 404.753,57.8078 404,40.5C 406.865,27.3025 415.031,20.1358 428.5,19C 448.167,18.3333 467.833,18.3333 487.5,19C 499.164,20.5057 507.164,26.6723 511.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#9d75cc",
    d: "M 105.5,90.5 C 105.5,100.167 105.5,109.833 105.5,119.5C 83.2418,120.489 60.9085,120.822 38.5,120.5C 38.2526,114.459 38.5859,108.459 39.5,102.5C 38.9118,98.7748 38.2451,95.1081 37.5,91.5C 60.2417,91.8222 82.9084,91.4889 105.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#9d75cc",
    d: "M 293.5,91.5 C 291.679,101.023 291.012,110.689 291.5,120.5C 267.833,120.5 244.167,120.5 220.5,120.5C 220.822,114.642 220.489,108.975 219.5,103.5C 219.276,99.8212 218.942,96.1545 218.5,92.5C 243.328,91.5023 268.328,91.169 293.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#9d75cc",
    d: "M 472.5,92.5 C 471.994,101.785 471.994,111.118 472.5,120.5C 450.167,120.5 427.833,120.5 405.5,120.5C 405.5,111.167 405.5,101.833 405.5,92.5C 427.931,91.1738 450.264,91.1738 472.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#9b72cb",
    d: "M 219.5,103.5 C 220.489,108.975 220.822,114.642 220.5,120.5C 244.167,120.5 267.833,120.5 291.5,120.5C 291.5,141.833 291.5,163.167 291.5,184.5C 290.515,180.366 290.182,176.032 290.5,171.5C 266.833,171.5 243.167,171.5 219.5,171.5C 219.5,148.833 219.5,126.167 219.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#9b72cb",
    d: "M 105.5,119.5 C 106.363,137.007 108.363,154.341 111.5,171.5C 87.1667,171.5 62.8333,171.5 38.5,171.5C 37.2854,154.496 37.2854,137.496 38.5,120.5C 60.9085,120.822 83.2418,120.489 105.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#9b72cb",
    d: "M 405.5,120.5 C 427.833,120.5 450.167,120.5 472.5,120.5C 473.715,137.496 473.715,154.496 472.5,171.5C 465.167,171.5 457.833,171.5 450.5,171.5C 443.5,162.167 436.5,162.167 429.5,171.5C 419.418,171.193 409.418,171.526 399.5,172.5C 402.422,155.286 404.422,137.953 405.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2bfe6",
    d: "M 450.5,171.5 C 449.761,182.362 447.927,193.028 445,203.5C 440.8,207.714 435.966,208.548 430.5,206C 428.951,204.786 427.785,203.286 427,201.5C 427.664,191.515 428.497,181.515 429.5,171.5C 436.5,162.167 443.5,162.167 450.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#976dca",
    d: "M 38.5,171.5 C 62.8333,171.5 87.1667,171.5 111.5,171.5C 115.51,199.826 124.843,226.16 139.5,250.5C 113.833,250.5 88.1667,250.5 62.5,250.5C 53.7188,236.346 47.5522,221.012 44,204.5C 41.7422,193.521 39.9089,182.521 38.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#976dca",
    d: "M 219.5,171.5 C 243.167,171.5 266.833,171.5 290.5,171.5C 290.182,176.032 290.515,180.366 291.5,184.5C 291.5,202.167 291.5,219.833 291.5,237.5C 290.515,241.634 290.182,245.968 290.5,250.5C 266.833,250.5 243.167,250.5 219.5,250.5C 219.5,224.167 219.5,197.833 219.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#976dca",
    d: "M 429.5,171.5 C 428.497,181.515 427.664,191.515 427,201.5C 427.785,203.286 428.951,204.786 430.5,206C 435.966,208.548 440.8,207.714 445,203.5C 447.927,193.028 449.761,182.362 450.5,171.5C 457.833,171.5 465.167,171.5 472.5,171.5C 470.453,193.563 465.286,214.896 457,235.5C 454.646,240.887 451.812,245.887 448.5,250.5C 440.5,250.5 432.5,250.5 424.5,250.5C 427.144,246.33 429.644,241.997 432,237.5C 432.833,227.008 428,222.842 417.5,225C 413.301,229.899 409.468,235.066 406,240.5C 405.341,243.888 405.508,247.221 406.5,250.5C 394.784,251.144 383.451,250.478 372.5,248.5C 386.549,225.047 395.549,199.713 399.5,172.5C 409.418,171.526 419.418,171.193 429.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2bfe6",
    d: "M 424.5,250.5 C 418.5,255.833 412.5,255.833 406.5,250.5C 405.508,247.221 405.341,243.888 406,240.5C 409.468,235.066 413.301,229.899 417.5,225C 428,222.842 432.833,227.008 432,237.5C 429.644,241.997 427.144,246.33 424.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#9468c8",
    d: "M 291.5,237.5 C 291.085,249.562 291.585,261.562 293,273.5C 297.147,282.83 304.314,288.163 314.5,289.5C 326.139,287.234 336.806,282.734 346.5,276C 356.441,267.897 365.107,258.73 372.5,248.5C 383.451,250.478 394.784,251.144 406.5,250.5C 412.5,255.833 418.5,255.833 424.5,250.5C 432.5,250.5 440.5,250.5 448.5,250.5C 432.85,278.475 409.85,297.809 379.5,308.5C 296.5,307.167 213.5,307.167 130.5,308.5C 100.714,297.371 78.0476,278.038 62.5,250.5C 88.1667,250.5 113.833,250.5 139.5,250.5C 149.875,264.708 162.875,275.874 178.5,284C 192.003,292.405 204.17,290.905 215,279.5C 216.893,276.382 218.226,273.049 219,269.5C 219.5,263.175 219.666,256.842 219.5,250.5C 243.167,250.5 266.833,250.5 290.5,250.5C 290.182,245.968 290.515,241.634 291.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#9164c6",
    d: "M 130.5,308.5 C 213.5,307.167 296.5,307.167 379.5,308.5C 358.464,317.088 336.464,321.922 313.5,323C 302.338,324.494 295.171,330.661 292,341.5C 291.5,348.158 291.334,354.825 291.5,361.5C 267.5,361.5 243.5,361.5 219.5,361.5C 219.856,353.762 219.356,346.095 218,338.5C 214.349,329.189 207.516,324.022 197.5,323C 174.354,321.672 152.02,316.838 130.5,308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#8d5fc5",
    d: "M 219.5,361.5 C 243.5,361.5 267.5,361.5 291.5,361.5C 291.333,379.17 291.5,396.836 292,414.5C 292.315,416.586 292.815,418.586 293.5,420.5C 268.167,421.833 242.833,421.833 217.5,420.5C 218.185,418.586 218.685,416.586 219,414.5C 219.5,396.836 219.667,379.17 219.5,361.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#8a5bc3",
    d: "M 217.5,420.5 C 242.833,421.833 268.167,421.833 293.5,420.5C 298.98,436.146 309.647,446.646 325.5,452C 335.246,454.519 344.912,457.186 354.5,460C 358.227,462.955 360.227,466.788 360.5,471.5C 290.5,471.5 220.5,471.5 150.5,471.5C 151.265,466.141 153.932,461.974 158.5,459C 167.519,456.828 176.519,454.495 185.5,452C 201.353,446.646 212.02,436.146 217.5,420.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#8859c3",
    d: "M 150.5,471.5 C 220.5,471.5 290.5,471.5 360.5,471.5C 361.814,482.641 356.814,489.475 345.5,492C 285.5,492.667 225.5,492.667 165.5,492C 154.201,489.514 149.201,482.68 150.5,471.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychology);
export default __webpack_public_path__ + "static/media/psychology.831978c4719fd6a11c41804260d10fc4.svg";
export { ForwardRef as ReactComponent };